import { connect } from 'react-redux'
import Comments from './comments'
import { withRouter } from 'react-router-dom'
import { fetchComments } from '../../../../stores/comments/comments.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getFetchRequest } from '../../../../stores/comments/comments.selectors'

const mapStateToProps = state => {
  const fetchRequest = getFetchRequest(state)
  return {
    pending:
      fetchRequest.params && fetchRequest.params.initial && fetchRequest.pending
  }
}

const mapDispatchToProps = (dispatch, { match }) => ({
  onMount: () =>
    dispatch(fetchComments(match.params.id, { initial: true })).catch(
      errorHandler
    )
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Comments)
)
